const React = require("react");
const createReactClass = require("create-react-class");
const OfficeModal = require("./OfficeModal");
const {ErrorIcon} = require("../../core/view/ErrorIcon");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const Copy = require("../data/CopyTable").getDisconnectCopy();

const styles = require("./styles/DisconnectModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "DisconnectModal",

		// Used by vault update HOC
		vaultEvents: {
			showOfficeDisconnectedModal: function(type) {
				this.setState({isOpen: true, type});
			},
		},

		getInitialState: function() {
			return {
				isOpen: false,
				type: "basic",
			};
		},

		onClose: function() {
			this.setState({isOpen: false, type: null});
		},

		render: function() {
			if (this.state.isOpen) {
				return (
					<OfficeModal
						onClose={this.onClose}
						closeOnEsc={true}
						portalContainer={null}
						level="warning"
						modalClass={styles.main}
					>
						<div className={styles.container}>
							<div className={styles.aboveButton}>
								<ErrorIcon />
								<div className={styles.message}>
									{Copy[this.state.type] || Copy.basic}
								</div>
							</div>
							<div className={styles.button} onClick={this.onClose}>
								Okay
							</div>
						</div>
					</OfficeModal>
				);
			} else {
				return null;
			}
		},
	})
);
